import { OnsiteVisit } from '../shared/OnsiteVisit.js';

function OnsiteCreateVisitModal($interval, $rootScope, onsiteService, onsiteSettingsService, twilioService) {
    'use strict';

    var visitProto = {
        logId: $rootScope.selectedLog.id,
        noteId: null,
        site: null,
        personLastName: "",
        personFirstName: "",
        timeIn: null,
        timeOut: null,
        noteText: " ",
        comments: [],
        userName: "",
        phoneNumber: "",
        inMessageId: "manually created site visit",
        outMessageId: null
    };


    return {
        redirect: 'E',
        replace: true,
        scope: {},
		template: require('./create-visit-modal.html'),

        link: function (scope) {
            var escapeRegExp = function (str) {
                return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
            };

            scope.availableSites = [];
            scope.knownUsers = [];
            scope.dateOptions = {
                format: "MM/DD/YYYY HH:mm:ss",
                showTodayButton: true,
                showClear: true,
                showClose: true,
                useCurrent: false,
                sideBySide: true
            };
            scope.sending = false;
            scope.visit = _.create({}, visitProto);

            scope.onPhoneNumberChanged = function () {

                if (scope.phoneNumberValid()) {
                    var tempPhone = escapeRegExp(scope.visit.phoneNumber);
                    var matches = scope.knownUsers.filter(function (user) {
                        return user.phoneNumber.match(tempPhone);
                    });

                    if (matches && matches.length === 1) {
                        scope.visit.phoneNumber = matches[0].phoneNumber;
                        scope.visit.userName = matches[0].contactName;
                    }
                } else {
                    scope.visit.userName = '';
                }
            };

            scope.phoneNumberValid = function () {
                if (scope.visit.phoneNumber) {
                    var phoneRegex = /\d{10}/;
                    var matches = scope.visit.phoneNumber.match(phoneRegex);
                    return (matches && matches.length > 0);
                }
                return false;
            };

            scope.validateVisit = function () {
                var phoneNumberValid = scope.phoneNumberValid();
                return (phoneNumberValid && scope.visit.site && scope.visit.userName);
            };

            scope.hideModal = function () {
                $('#create-visit-modal').modal('hide');
                scope.sending = false;
                scope.visit = _.create({}, visitProto);
            };

            scope.createSiteVisit = function () {
                var visit = _.assign({}, scope.visit);
                scope.sending = true;

                onsiteService.addVisit(visit).then(function (retVisit) {

                    twilioService.sendSMSText({
                        logId: retVisit.logId,
                        noteId: retVisit.id,
                        contactName: visit.userName,
                        toNumber: visit.phoneNumber,
                        message: "You have been checked into site '" + visit.site.siteName + "'" ,
                        onsiteComment: false,
                        actionType: "checkIn"
                    });

                    scope.$emit('visit-added', new OnsiteVisit(retVisit));
                    scope.hideModal();
                });
            };

            $('#create-visit-modal').on('show.bs.modal', function () {
                onsiteService.getKnownUsers($rootScope.selectedLog.id).then(function (dat) {
                    scope.knownUsers = dat._embedded.onsiteContacts;
                });

                onsiteService.getAvailableSites($rootScope.selectedLog.id).then(function (sites) {
                    scope.availableSites = sites;
                });

                scope.visit.timeIn = new Date();
            })
        }
    }
}

angular.module('onsite').directive('onsiteCreateVisitModal', ['$interval', '$rootScope', 'onsiteService', 'onsiteSettingsService', 'twilioService', OnsiteCreateVisitModal]);
